const routers = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/archive/list/index'),
    meta: { title: '客户信息', keepAlive: true, requireAuth: true },
  },
  {
    path: '/weixin',
    name: 'Weixin',
    component: () => import('@/views/weixin/index'),
    meta: { title: '抱歉，出错了', keepAlive: true },
  },
  {
    path: '/binding',
    name: 'Binding',
    component: () => import('@/views/binding/index'),
    meta: { title: '用户绑定' },
  },
  {
    path: '/usercenter',
    name: 'UserCenter',
    component: () => import('@/views/usercenter/index'),
    meta: { title: '个人中心', requireAuth: true },
  },
  {
    path: '/information_input',
    name: 'Information_input',
    component: () => import('@/views/Information_input/index'),
    meta: { title: '投诉保修', requireAuth: true },
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('@/views/feedback/index'),
    meta: { title: '结果反馈', requireAuth: true },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/profile/index'),
    meta: { title: '个人资料', requireAuth: true },
  },
  {
    path: '/changephone',
    name: 'ChangePhone',
    component: () => import('@/views/changephone/index'),
    meta: { title: '修改联系电话', requireAuth: true },
  },
  {
    path: '/changeemail',
    name: 'ChangeEmail',
    component: () => import('@/views/changeemail/index'),
    meta: { title: '修改电子邮箱', requireAuth: true },
  },
  {
    path: '/archive',
    name: 'Archive',
    component: () => import('@/views/archive/list/index'),
    meta: { title: '客户信息', requireAuth: true },
  },
  {
    path: '/archive/edit',
    name: 'ArchiveEdit',
    component: () => import('@/views/archive/edit/index'),
    meta: { title: '修改电话', requireAuth: true },
  },
  {
    path: '/archive/details',
    name: 'ArchiveDetails',
    component: () => import('@/views/archive/details/index'),
    meta: { title: '房屋表具信息', requireAuth: true },
  },
  {
    path: '/payment',
    name: 'Payment',
    component: () => import('@/views/payment/list/index'),
    meta: { title: '欠费列表', requireAuth: true },
  },
  {
    path: '/payment/pay',
    name: 'PaymentPay',
    component: () => import('@/views/payment/pay/index'),
    meta: { title: '支付页面', requireAuth: true },
  },
  {
    path: '/payment/log',
    name: 'PaymentLog',
    component: () => import('@/views/payment/log/index'),
    meta: { title: '缴费记录', requireAuth: true },
  },
  {
    path: '/payment/result',
    name: 'PaymentResult',
    component: () => import('@/views/payment/result/index'),
    meta: { title: '支付结果', requireAuth: true },
  },
  {
    path: '/payment/details',
    name: 'PaymentDetails',
    component: () => import('@/views/payment/details/index'),
    meta: { title: '缴费记录', requireAuth: true },
  },
  {
    path: '/recharge',
    name: 'Recharge',
    component: () => import('@/views/recharge/dzlist/index'),
    meta: { title: '充值缴费', keepAlive: false, requireAuth: true },
  },
  {
    path: '/recharge/charge',
    name: 'Charge',
    component: () => import('@/views/recharge/charge/index'),
    meta: { title: '充值缴费', keepAlive: false, requireAuth: true },
  },
  {
    path: '/recharge/dzlist',
    name: 'RechargeList',
    component: () => import('@/views/recharge/list/index'),
    meta: { title: '充值缴费', keepAlive: false, requireAuth: true },
  },
  {
    path: '/feeinfo',
    name: 'Feeinfo',
    component: () => import('@/views/feeinfo/list/index'),
    meta: { title: '计费项目', keepAlive: false, requireAuth: true },
  },
  {
    path: '/feeinfo/details',
    name: 'FeeinfoDetails',
    component: () => import('@/views/feeinfo/details/index'),
    meta: { title: '量费信息', keepAlive: false, requireAuth: true },
  },
  {
    path: '/topup',
    name: 'Topup',
    component: () => import('@/views/topup/query/index'),
    meta: { title: '代充值查询' },
  },
  {
    path: '/online_area',
    name: 'OnlineArea',
    component: () => import('@/views/online_area/index'),
    meta: { title: '相关说明' },
  },
  {
    path: '/online_area/bangding',
    name: 'OnlineAreaBangding',
    component: () => import('@/views/online_area/bangding/index'),
    meta: { title: '公众号绑定' },
  },
  {
    path: '/online_area/jiaofei',
    name: 'OnlineAreaJiaofei',
    component: () => import('@/views/online_area/jiaofei/index'),
    meta: { title: '公众号充值缴费' },
  },
  {
    path: '/online_area/yucun',
    name: 'OnlineAreaYucun',
    component: () => import('@/views/online_area/yucun/index'),
    meta: { title: '预存余额查询' },
  },
  {
    path: '/online_area/yufu',
    name: 'OnlineAreaYufu',
    component: () => import('@/views/online_area/yufu/index'),
    meta: { title: '预付费表具相关说明' },
  },
  {
    path: '/online_area/biaoju',
    name: 'OnlineAreaBiaoju',
    component: () => import('@/views/online_area/biaoju/index'),
    meta: { title: '表具操作方法' },
  },
  {
    path: '/online_area/qita',
    name: 'OnlineAreaQita',
    component: () => import('@/views/online_area/qita/index'),
    meta: { title: '其他常见问题' },
  },
  {
    path: '/announcement',
    name: 'Announcement',
    component: () => import('@/views/announcement/index'),
    meta: { title: '联系我们' },
  },
  {
    path: '/topup/list',
    name: 'TopupList',
    component: () => import('@/views/topup/list/index'),
    meta: { title: '代充值列表' },
  },
  {
    path: '/topup/pay',
    name: 'TopupPay',
    component: () => import('@/views/topup/pay/index'),
    meta: { title: '代充值支付' },
  },
  {
    path: '/topup/result',
    name: 'TopupResult',
    component: () => import('@/views/topup/result/index'),
    meta: { title: '代充值支付结果' },
  },
  {
    path: '/meterreading',
    name: 'Meterreading',
    component: () => import('@/views/meterreading/dzList/index'),
    meta: { title: '选择地址', keepAlive: false, requireAuth: true },
  },
  {
    path: '/meterreading/jldList',
    name: 'MeterreadingJldList',
    component: () => import('@/views/meterreading/jldList/index'),
    meta: { title: '选择表具', keepAlive: false, requireAuth: true },
  },
  {
    path: '/meterreading/input',
    name: 'MeterreadingInput',
    component: () => import('@/views/meterreading/input/index'),
    meta: { title: '表底录入', keepAlive: false, requireAuth: true },
  },
  {
    path: '/invoice/fpgl',
    name: 'InvoiceFpgl',
    component: () => import('@/views/invoice/fpgl/index'),
    meta: { title: '获取发票', requireAuth: true },
  },
  {
    path: '/invoice/dzlist',
    name: 'InvoiceDzlist',
    component: () => import('@/views/invoice/dzlist/index'),
    meta: { title: '获取发票', requireAuth: true },
  },

  {
    path: '/deposit/list',
    name: 'DepositList',
    component: () => import('@/views/deposit/list/index'),
    meta: { title: '账户余额', requireAuth: true },
  },
  {
    path: '/deposit/details',
    name: 'DepositDetails',
    component: () => import('@/views/deposit/details/index'),
    meta: { title: '账户余额', requireAuth: true },
  },
  {
    path: '/ywbl',
    name: 'Ywbl',
    component: () => import('@/views/ywbl/index'),
    meta: { title: '业务办理', requireAuth: true },
  },
  {
    path: '/ywbl/khkh',
    name: 'Ywbl_Khkh',
    component: () => import('@/views/ywbl/khkh/index'),
    meta: { title: '客户开户', requireAuth: true },
  },
  {
    path: '/ywbl/khkh/khgd',
    name: 'Ywbl_Khgd',
    component: () => import('@/views/ywbl/khkh/khgd'),
    meta: { title: '客户开户-工单', requireAuth: true },
  },
  {
    path: '/ywbl/khkh/khsq',
    name: 'Ywbl_Khsq',
    component: () => import('@/views/ywbl/khkh/khsq'),
    meta: { title: '客户开户-申请', requireAuth: true },
  },
  {
    path: '/ywbl/fcdj',
    name: 'Ywbl_Fcdj',
    component: () => import('@/views/ywbl/fcdj/index'),
    meta: { title: '房产登记', requireAuth: true },
  },
  {
    path: '/ywbl/jybj',
    name: 'Ywbl_Jybj',
    component: () => import('@/views/ywbl/jybj/index'),
    meta: { title: '接引(表具)', requireAuth: true },
  },
  {
    path: '/ywbl/jyfbj',
    name: 'Ywbl_Jyfbj',
    component: () => import('@/views/ywbl/jyfbj/index'),
    meta: { title: '接引(非表具)', requireAuth: true },
  },
  {
    path: '/ywbl/cb',
    name: 'Ywbl_Cb',
    component: () => import('@/views/ywbl/cb/index'),
    meta: { title: '断引（表具）', requireAuth: true },
  },
  {
    path: '/ywbl/dg',
    name: 'Ywbl_Dg',
    component: () => import('@/views/ywbl/dg/index'),
    meta: { title: '断引（非表具）', requireAuth: true },
  },
  {
    path: '/ywbl/cq',
    name: 'Ywbl_Cq',
    component: () => import('@/views/ywbl/cq/index'),
    meta: { title: '拆迁', requireAuth: true },
  },
  {
    path: '/ywbl/xh',
    name: 'Ywbl_Xh',
    component: () => import('@/views/ywbl/xh/index'),
    meta: { title: '销户', requireAuth: true },
  },
  {
    path: '/ywbl/xh',
    name: 'Ywbl_Xhsq',
    component: () => import('@/views/ywbl/xh/Xhsq'),
    meta: { title: '销户-申请', requireAuth: true },
  },
  {
    path: '/ywbl/xh',
    name: 'Ywbl_Xhgd',
    component: () => import('@/views/ywbl/xh/Xhgd'),
    meta: { title: '销户-工单', requireAuth: true },
  },
  {
    path: '/ywbl/gh',
    name: 'Ywbl_Gh',
    component: () => import('@/views/ywbl/gh/index'),
    meta: { title: '过户', requireAuth: true },
  },
  {
    path: '/ywbl/hb',
    name: 'Ywbl_Hb',
    component: () => import('@/views/ywbl/hb/index'),
    meta: { title: '换表', requireAuth: true },
  },
  {
    path: '/ywbl/cqbg',
    name: 'Ywbl_Cqbg',
    component: () => import('@/views/ywbl/cqbg/index'),
    meta: { title: '产权变更', requireAuth: true },
  },
  {
    path: '/ywbl/khkh',
    name: 'Ywbl_Khkh',
    component: () => import('@/views/ywbl/khkh/index'),
    meta: { title: '客户开户', requireAuth: true },
  },
  {
    path: '/ywbl/khkh',
    name: 'Ywbl_Khsq',
    component: () => import('@/views/ywbl/khkh/khsq'),
    meta: { title: '客户开户-申请', requireAuth: true },
  },
  {
    path: '/ywbl/khkh',
    name: 'Ywbl_Khgd',
    component: () => import('@/views/ywbl/khkh/khgd'),
    meta: { title: '客户开户-工单', requireAuth: true },
  },
  {
    path: '/ywbl/nqtfg',
    name: 'Ywbl_Nqtfg',
    component: () => import('@/views/ywbl/nqtfg/index'),
    meta: { title: '暖气停复供', requireAuth: true },
  },
  {
    path: '/ywbl/fwzl',
    name: 'Ywbl_Fwzl',
    component: () => import('@/views/ywbl/fwzl/index'),
    meta: { title: '房屋租赁', requireAuth: true },
  },
  {
    path: '/ywbl/jyfbj',
    name: 'Ywbl_Jysq',
    component: () => import('@/views/ywbl/jyfbj/jysq'),
    meta: { title: '接引(非表具)-申请', requireAuth: true },
  },
  {
    path: '/ywbl/jyfbj',
    name: 'Ywbl_Jygd',
    component: () => import('@/views/ywbl/jyfbj/jygd'),
    meta: { title: '接引(非表具)-工单', requireAuth: true },
  },
  {
    path: '/ywbl/cb',
    name: 'Ywbl_Cbsq',
    component: () => import('@/views/ywbl/cb/cbsq'),
    meta: { title: '断引（表具）-申请', requireAuth: true },
  },
  {
    path: '/ywbl/cb',
    name: 'Ywbl_Cbgd',
    component: () => import('@/views/ywbl/cb/cbgd'),
    meta: { title: '断引（表具）-工单', requireAuth: true },
  },
  {
    path: '/ywbl/hb',
    name: 'Ywbl_Hbsq',
    component: () => import('@/views/ywbl/hb/hbsq'),
    meta: { title: '换表-申请', requireAuth: true },
  },
  {
    path: '/ywbl/hb',
    name: 'Ywbl_Hbgd',
    component: () => import('@/views/ywbl/hb/hbgd'),
    meta: { title: '换表-工单', requireAuth: true },
  },
  {
    path: '/ywbl/cq',
    name: 'Ywbl_Cqsq',
    component: () => import('@/views/ywbl/cq/cqsq'),
    meta: { title: '拆迁-申请', requireAuth: true },
  },
  {
    path: '/ywbl/cq',
    name: 'Ywbl_Cqgd',
    component: () => import('@/views/ywbl/cq/cqgd'),
    meta: { title: '拆迁-工单', requireAuth: true },
  },
  {
    path: '/ywbl/cqbg',
    name: 'Ywbl_Cqbgsq',
    component: () => import('@/views/ywbl/cqbg/cqbgsq'),
    meta: { title: '产权变更-申请', requireAuth: true },
  },
  {
    path: '/ywbl/cqbg',
    name: 'Ywbl_Cqbggd',
    component: () => import('@/views/ywbl/cqbg/cqbggd'),
    meta: { title: '产权变更-工单', requireAuth: true },
  },
  {
    path: '/ywbl/fwzl',
    name: 'Ywbl_Fwzlsq',
    component: () => import('@/views/ywbl/fwzl/fwzlsq'),
    meta: { title: '房屋租赁-申请', requireAuth: true },
  },
  {
    path: '/ywbl/fwzl',
    name: 'Ywbl_Fwzlgd',
    component: () => import('@/views/ywbl/fwzl/fwzlgd'),
    meta: { title: '房屋租赁-工单', requireAuth: true },
  },
  {
    path: '/ywbl/fcdj',
    name: 'Ywbl_Fcdjsq',
    component: () => import('@/views/ywbl/fcdj/fcdjsq'),
    meta: { title: '房产登记-申请', requireAuth: true },
  },
  {
    path: '/ywbl/fcdj',
    name: 'Ywbl_Fcdjgd',
    component: () => import('@/views/ywbl/fcdj/fcdjgd'),
    meta: { title: '房产登记-工单', requireAuth: true },
  },
  {
    path: '/ywbl/jybj',
    name: 'Ywbl_Jybjsq',
    component: () => import('@/views/ywbl/jybj/jybjsq'),
    meta: { title: '接引(表具)-申请', requireAuth: true },
  },
  {
    path: '/ywbl/jybj',
    name: 'Ywbl_Jybjgd',
    component: () => import('@/views/ywbl/jybj/jybjgd'),
    meta: { title: '接引(表具)-工单', requireAuth: true },
  },
  {
    path: '/ywbl/dg',
    name: 'Ywbl_Dgsq',
    component: () => import('@/views/ywbl/dg/dgsq'),
    meta: { title: '断引（非表具）-申请', requireAuth: true },
  },
  {
    path: '/ywbl/dg',
    name: 'Ywbl_Dggd',
    component: () => import('@/views/ywbl/dg/dggd'),
    meta: { title: '断引（非表具）-工单', requireAuth: true },
  },
  {
    path: '/ywbl/nqtfg',
    name: 'Ywbl_Nqtfgsq',
    component: () => import('@/views/ywbl/nqtfg/nqtfgsq'),
    meta: { title: '暖气停复供-申请', requireAuth: true },
  },
  {
    path: '/ywbl/nqtfg',
    name: 'Ywbl_Nqtfggd',
    component: () => import('@/views/ywbl/nqtfg/nqtfggd'),
    meta: { title: '暖气停复供-工单', requireAuth: true },
  },
  {
    path: '/ywbl/gh',
    name: 'Ywbl_Ghsq',
    component: () => import('@/views/ywbl/gh/ghsq'),
    meta: { title: '过户-申请', requireAuth: true },
  },
  {
    path: '/ywbl/gh',
    name: 'Ywbl_Ghgd',
    component: () => import('@/views/ywbl/gh/ghgd'),
    meta: { title: '过户-工单', requireAuth: true },
  },
  {
    path: '/wczxx',
    name: 'Wczxx',
    component: () => import('@/views/wczxx/list/index'),
    meta: { title: '当前余额', keepAlive: false, requireAuth: true },
  },
  {
    path: '/wczxx/details',
    name: 'WczxxDetails',
    component: () => import('@/views/wczxx/details/index'),
    meta: { title: '当前余额', keepAlive: false, requireAuth: true },
  },
];

export default routers;



// WEBPACK FOOTER //
// ./src/router/routers.js